<template>
  <div
    class="overflow-hidden duration-300"
    :class="{
      'h-[15rem] md:h-[11rem]': validationComponentIsVisible,
      'h-[0]': !validationComponentIsVisible,
    }"
  >
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <AppDataProperty
      contentId="kycData"
      @dataAvailable="
        data => {
          kycData = data?.metaData || {}
        }
      "
    />
    <div class="px-8 pt-4 pb-2">
      <div
        class="w-full shadow-t-lg border-2 border-white rounded-2xl relative overflow-hidden"
      >
        <div
          class="absolute w-full h-full"
          style="background: linear-gradient(to bottom, #ffdddc 10%, #fffcfc)"
        ></div>

        <div class="flex gap-4 items-center p-4 md:p-4 relative">
          <div
            class="rounded-full min-w-14 w-14 h-14 shadow-b-2xl p-0 bg-[#ffc8c6] mb-auto md:mb-0"
          >
            <LottieComponent
              v-if="
                kycData?.isPending ||
                (kycData?.isFilled && !kycData?.isRejected)
              "
              :src="notificationLottie"
              loop
            />
            <div v-else class="p-2">
              <LottieComponent :src="alertCircleLottie" loop />
            </div>
          </div>
          <div class="flex w-full flex-col md:flex-row gap-2">
            <div>
              <div class="text-base md:text-xl title-color">
                Validation de compte
              </div>
              <div class="text-xs md:text-sm">
                <span v-if="kycData?.isPending">
                  La validation de votre compte est en cours. Vous serez notifié
                  après validation
                </span>
                <span v-else-if="kycData?.isRejected">
                  Votre compte a été rejeté, veuillez remplire à nouveau les
                  informations
                </span>
                <span v-else-if="!kycData?.isFilled">
                  Pour éviter la suspension de votre boutique, veuillez fournir
                  des informations sur votre entreprise.
                </span>
                <span v-else-if="kycData?.isFilled">
                  Vos informations ont été remplies. Vous serez notifié après
                  validation
                </span>
              </div>
            </div>
            <div class="md:ml-auto min-w-max">
              <div v-if="kycData?.isRejected || !kycData?.isFilled">
                <router-link
                  :to="`/validation?id=${userData?.reference}`"
                  class="buttonComponent py-4 px-6 rounded-2xl text-sm md:test-lg"
                >
                  Completer mes informations
                </router-link>
              </div>
            </div>
          </div>
          <div class="o" @click="hideModal = true">
            <div class="w-8 h-8">
              <img
                src="@/assets/images/all/close.svg"
                class="w-full h-full"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserProperty from '../user/UserProperty.vue'
import AppDataProperty from '../appData/AppDataProperty.vue'
import alertCircleLottie from '@/assets/lotties/alertCircle.json'
import notificationLottie from '@/assets/lotties/notification-V4.json'
import LottieComponent from '../utils/LottieComponent.vue'

export default defineComponent({
  name: 'UserValidationTopSection',
  components: { UserProperty, AppDataProperty, LottieComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
      userData: {},
      kycData: {},
      hideModal: false,
      alertCircleLottie,
      notificationLottie,
    }
  },
  mounted() {
    const id2 = this.$Events.handleEvent('logout_done', () => {
      this.userData = {}
    })
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {},
  computed: {
    hideOnCurrentMenu() {
      if (this.$route.name == 'preferences') return true
      if (this.$route.name == 'chat') return true
      if (this.$route.name == 'proSubscription') return true
      return false
    },
    validationComponentIsVisible() {
      return (
        !this.hideOnCurrentMenu &&
        !this.hideModal &&
        !this.kycData?.isValidated &&
        this.userData?.email
      )
    },
  },
  watch: {},
})
</script>
